import { ThemeProvider } from '@mui/material/styles';
import { observer } from 'mobx-react';
import React from 'react';
import App from './App';
import LayoutStore from './store/LayoutStore';
import Ambiente from './utils/Ambiente';
import ReactDOM from 'react-dom/client';
import { Buffer } from 'buffer';
import CssBaseline from '@mui/material/CssBaseline';

(globalThis as any).Buffer = Buffer;
if (typeof global === 'undefined') {
    (window as any).global = window;
}

const app = document.getElementById('root');

Ambiente.criarAmbiente().then(() => {
    ReactDOM.createRoot(app!).render(<InicioObserver />);
}).catch(erro => {
    ReactDOM.createRoot(app!).render(
        <div>
            Erro ao carregar os ambientes. Tente entrar no endereço{' '}
            <a href={Ambiente.urlLogus + '/configs'}>{Ambiente.urlLogus}</a>,
            aceitar o certificado e entre novamente no Gabinete Eletrônico ou entre em
            contato com o suporte ao usuário (3043-4040).
        </div>
    );
    console.error('Erro ao carregar as variáveis de ambiente.', erro);
});

class Inicio extends React.Component {
    render() {
        const isRotaIndependente = window.location.pathname.startsWith('/resumoDocumentosAguia/');

        return (
            <ThemeProvider theme={LayoutStore.theme}>
                <CssBaseline />
                <div className={isRotaIndependente ? 'resumo-aguia' : 'conteudo-principal'}>
                    <App />
                </div>
            </ThemeProvider>
        );
    }
}

const InicioObserver = observer(Inicio);

export default InicioObserver;
